var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconChatActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25",
    width: 28,
    height: 28,
    "aria-hidden": "true",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5,0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5 4.5A8.5 8.5 0 0 0 4.2 15.78c-.19 1.41-.89 3.06-1.52 4.24a.75.75 0 0 0 .8 1.09c1.7-.24 3.97-.91 5.73-2.01A8.5 8.5 0 0 0 20.5 4.5ZM9 10.75a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5Zm3 0a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5Zm3 0a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChatActive);
export default __webpack_public_path__ + "static/media/icon-chat-active.128acbb36a5ee925397f8397965f6437.svg";
export { ForwardRef as ReactComponent };